// Per-site eshop visibility for this web-app's SITE_ID, with a legacy server fallback.
//
// nexio writes `eshopSites: string[]` on products and `options.eshopSites` on category
// tree nodes (keeping the legacy `eshop` boolean in sync). When SITE_ID is configured AND
// the entity carries a per-site list, visibility is decided by that list. Otherwise we fall
// back to the legacy `eshop` boolean (categories) or to `defaultVisible` (products).
//
// Leaving SITE_ID empty therefore preserves the app's existing eshop-boolean behaviour
// exactly — the per-site logic only activates once an id is set in constants.js.
import { SITE_ID } from '../assets/globalConstants';

export const isVisibleForSite = (entity, { defaultVisible = false } = {}) => {
  if (!entity) return false;
  const sites = entity.eshopSites ?? entity.options?.eshopSites;
  if (SITE_ID && Array.isArray(sites)) return sites.includes(SITE_ID);
  const legacy = entity.eshop ?? entity.options?.eshop;
  if (legacy === true) return true;
  if (legacy === false) return false;
  return defaultVisible;
};

// Product list filter for the eshop catalog.
//
// The dashboard's "show in eshop / delivery" flag is `enabledForDelivery`, so THAT is the
// fallback when a product has no per-site list (not "show everything"). Once SITE_ID is set
// a product is shown when its `eshopSites` includes this site; a product with no per-site
// list falls back to `enabledForDelivery`, so an un-migrated catalog keeps its existing
// eshop visibility.
//
// Per-site eshop visibility applies only to the eshop catalog — QR/table ordering keeps the
// restaurant's full `enabled` menu untouched (its products are gated by `enabled`, not
// `enabledForDelivery`), so in table mode this is a pass-through.
export const filterProductsForSite = (products, isEshop = true) => {
  const list = products || [];
  if (!isEshop) return list;
  return list.filter((p) => {
    const sites = p?.eshopSites;
    if (SITE_ID && Array.isArray(sites)) return sites.includes(SITE_ID);
    return !!p?.enabledForDelivery;
  });
};
